<template>
  <v-app class="bckgrnd">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 >
            <v-text-field v-model="form.address" label="Address *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding-right: 5px">
            <v-text-field v-model="form.country" label="Country *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding-right: 5px">
            <v-autocomplete
              v-model="selectedState"
              :items="states"
              color="primary"
              label="Select State *"
              item-text="stateName"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding-right: 5px">
            <v-text-field v-model="form.city" label="City"></v-text-field>
          </v-flex>
          <v-flex xs12 md3 sm12>
            <v-text-field type="Number" v-model="form.pinCode" label="Pincode *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="form.landmark" label="Landmark"></v-text-field>
          </v-flex>
          
          <v-flex xs12 style="text-align:right">
            <v-btn depressed :loading="btnSave" color="#e53935" dark @click="onSubmit()">Save </v-btn>
            <v-btn depressed color="#212121" dark @click="back()">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create user",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Address Book",
          disabled: false,
          to: "/addressBook"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createUser"
        }
      ],
      states: null,
      selectedState: null,

      form: {
        address: null,
        city: null,
        country: "INDIA",
        landmark: null,
        pinCode: null
      }
    };
  },

  mounted() {
      this.axios
        .get(config.API + "States", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
        });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `AddressBooks`,
            {
              address: this.form.address,
              country: this.form.country,
              stateId : JSON.parse(this.selectedState),
              city: this.form.city,
              pinCode: JSON.parse(this.form.pinCode),
              landmark: this.form.landmark
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully created");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #bdbdbd !important;
  background-size:cover !important;
}
</style>
